import ICarLoan from "./ICarLoan";

export default class CarLoan implements ICarLoan
{
    constructor(public cuid: string = "",
                public proofOfIncome: boolean = false,
                public proofOfOtherIncome: boolean = false)
    {
    }
}
